declare namespace $ {

	export class $mol_icon_molecule extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=molecule.view.tree.d.ts.map